import { FunctionComponent, useEffect, useState } from "react";
import IconButtonField from "../Button/IconButtonField";
import Avatars from "../Avatar/Avatars";
import Menus from "../Menu/Menu";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { clearListuser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import { useLocation, useNavigate } from "react-router-dom";
import "./MenuBar.scss";
import { listMenu } from "../../Redux/Slices/Menu/ListMenuSlice";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../../Pages/Login/ILogin";
const MenuBar: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: menu_data, isLoading } = useAppSelector((state) => state.ListMenuSlice);

  const pathname = location.pathname.toLowerCase().split('/').filter(Boolean).join('/');

  const menuHeading = Array.isArray(menu_data?.data)
    ? menu_data?.data?.find((val) => {
      if (!val.path) return false;
      const menuPath = val.path.toLowerCase().split('/').filter(Boolean).join('/');
      return pathname === menuPath || pathname.endsWith(`/${menuPath}`) || menuPath.endsWith(`/${pathname}`);
    })
    : undefined;

  // Fallback title generation if not found in database manually
  const getFallbackHeading = (pathname: string): string => {
    const segments = pathname.split('/').filter(Boolean);
    const lastSegment = segments.pop() || '';
    
    // Handle template routes that contain 'tamplete' or just 'page'
    if (lastSegment.toLowerCase().includes('tamplete') || lastSegment.toLowerCase() === 'page') {
      // Try to find a meaningful prefix like 'instruction', 'onlineexam', etc.
      const meaningfulPart = lastSegment
        .toLowerCase()
        .replace('tamplete', '')
        .replace('page', '')
        .replace(/_/g, ' ');
      
      if (meaningfulPart.trim()) {
        return meaningfulPart
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }
      // If on a template route with no other meaningful parts, use the parent segment
      const parentSegment = segments.pop() || '';
      if (parentSegment) {
        return parentSegment
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }
    }
    
    // Default: capitalize the last segment
    return lastSegment
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const displayHeading = menuHeading?.menuname ?? getFallbackHeading(pathname);

  const [details, setDetails] = useState<ILoginResponse>({});

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
    dispatch(listMenu());
  }, [dispatch]);
  return (
    <div className="menu_main_block">
      <div className="menu_heading">{displayHeading}</div>
      {/* <div> */}
      <div className="user_info_block">
        <span className="username">{details?.username}</span>
        <Menus
          menuItems={[
            {
              menu: "Logout",
              onClick: () => {
                sessionStorage.clear();
                dispatch(clearListuser());
                dispatch(clearLoginStatus());
                dispatch(clearDashboardChart());
                navigate("/login");
              },
            },
          ]}
        >
          <IconButtonField onClick={() => { }}>
            <Avatars sx={{ height: "2.2rem", width: "2.2rem" }} />
          </IconButtonField>
        </Menus>
      </div>
    </div>
  );
};

export default MenuBar;
